function datesAreOnSameDay(first: Date, second: Date): boolean {
  return first.getDate() === second.getDate() &&
    first.getMonth() === second.getMonth() &&
    first.getFullYear() === second.getFullYear()
}

export default datesAreOnSameDay;